/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../http/http';
import { success, error } from '../../../services/alert-message';

const urlApi = 'v1/estados';

/**
*
* @param {*} param0
*/
export async function estadoList({ commit }, obj) {
  Loading.show();
  return (await http.get(`${urlApi}?${obj.filter}&include=cidades`)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
